import "./Patients.css";
import React, { useState, useEffect, useCallback } from "react";
import { useAppContext } from "../../classes/contexts/AppContext";
import SearchPanel from "./components/searchPanel/SearchPanel";
import ResultPanel from "./components/resultPanel/ResultPanel";
import { usePatientListDataFilter } from "../../hooks/queries/usePatientListDataFilter";
import { useFetchPatients } from "../../hooks/queries/useFetchPatients";

function Patients() {
  const [searchCriteria, setSearchCriteria] = useState({});

  const { hideSidebars } = useAppContext();
  const { refreshPatients: refreshFilter } =
    usePatientListDataFilter(searchCriteria);
  const { refreshPatients: refreshAllPatients } = useFetchPatients();

  useEffect(() => {
    hideSidebars();
  }, [hideSidebars]);

  const refresh = useCallback(() => {
    refreshFilter();
    refreshAllPatients();
  }, [refreshFilter, refreshAllPatients]);

  const handleSearch = useCallback(criteria => {
    setSearchCriteria(criteria);
  }, []);

  return (
    <div className="App-module-patients">
      <SearchPanel onSearch={handleSearch} refreshPatients={refresh} />
      <ResultPanel searchCriteria={searchCriteria} />
    </div>
  );
}

export default Patients;
